/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import PensionWiseLogo from "../../assets/pension-wise-logo.png";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import "./pensionwiseguidance.scss";
import { RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import { useSelector } from "react-redux";

const PensionWiseGuidance = (props) => {
  const { guide } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );
  const { editingPage, setEditingPage } = props;
  const [selectedCheck, setSelectedCheck] = useState([]);
  const [selectedRadio, setSelectedRadio] = useState("");

  useEffect(() => {
    setSelectedCheck([]);
    setSelectedRadio("");

    if (guide?.receivedGuidanceFromPensionWise) {
      setSelectedRadio("receivedGuidanceFromPensionWise");
    }
    if (guide?.receivedAdviceFromFCA) {
      const newItem = [...selectedCheck, "receivedAdviceFromFCA"];
      setSelectedCheck(newItem);
    }
    if (guide?.wishToOptOutGuidanceFromPW) {
      setSelectedRadio("wishToOptOutGuidanceFromPW");
    }
  }, []);

  function handleCheck(item) {
    if (selectedCheck.includes(item)) {
      let b = selectedCheck.filter((_item) => _item !== item);
      setSelectedCheck(b);
      return;
    }
    const newItem = [...selectedCheck, item];
    setSelectedCheck(newItem);
  }

  const handleBack = () => {
    props.makeInitialStepper(true);
  };
  const handleContinue = () => {
    props.nextStepIndentifier(
      RA_STEPS_IDENTIFIERS.RA_PENSION_WISE,
      [...selectedCheck, selectedRadio],
      "",
      editingPage
    );
    setEditingPage("");
  };
  return (
    <Card className="application-step">
      <Card.Body className="p-0 pension-wise-guidance ">
        <Row>
          <Col md={12} className="mb-fourty">
            <p className="guidance">Guidance and advice</p>
          </Col>
        </Row>
        <Row className="ourter-bg">
          <Col md={12} className="bg-text">
            <p>
              We’d strongly recommend that you seek additional guidance or
              financial advice before making your final choice about your
              pension.
            </p>
            <p>
              We’d also encourage you to take up a free appointment with Pension
              Wise, a government funded service from MoneyHelper that offers
              impartial guidance on your pension options.
            </p>
          </Col>
        </Row>
        <hr className="path-line pwg" />
        <Row className="pwd">
          <Col md={12} className="bg-text">
            <h3 className="heading">Pension Wise declaration</h3>
            <p className="subheading-text">
              Before we can proceed with your retirement application, the
              Government requires you to complete the following declaration.
              <span className="at-least-text">
                {" "}
                At least one box must be ticked.
              </span>
            </p>

            <p className="subheading-text">
              <CustomCheckbox
                name="read-understood"
                label="I’ve received guidance from Pension Wise in relation to this application in the last 12 months"
                variantName="custom-checkbox mt-4"
                value="receivedGuidanceFromPensionWise"
                checked={
                  selectedRadio === "receivedGuidanceFromPensionWise"
                }
                onChange={() =>
                  setSelectedRadio("receivedGuidanceFromPensionWise")
                }
              />
            </p>
            <p className="subheading-text">
              <CustomCheckbox
                name="pension-wise-guidance"
                type="checkbox"
                label="I’ve received advice from an FCA regulated financial adviser in relation to this application in the last 12 months"
                variantName="custom-checkbox mt-4"
                checked={selectedCheck.includes("receivedAdviceFromFCA")}
                onChange={() => handleCheck("receivedAdviceFromFCA")}
              />
            </p>
            <p className="subheading-text opt-out-text">
              <CustomCheckbox
                name="read-understood"
                label="I confirm that I wish to opt out of receiving guidance from Pension Wise*"
                variantName="custom-checkbox mt-4"
                value="wishToOptOutGuidanceFromPW"
                checked={selectedRadio === "wishToOptOutGuidanceFromPW"}
                onChange={() => setSelectedRadio("wishToOptOutGuidanceFromPW")}
              />
            </p>
            <div>
              {" "}
              <p className="subheading-text">
                *If you’ve not received Pension Wise guidance or financial
                advice from an FCA regulated adviser, we strongly recommend that
                you do this before proceeding.
              </p>
            </div>
          </Col>
        </Row>
        <div className="pension-wise-guidance">
          <Card className="book-appointment">
            <Card.Body className="p-0">
              <Row>
                <Col lg={12} md={12} sm={12}>
                  <div className="d-flex justify-content-between mb-3">
                    <h3 className="heading appoint-heading">
                      Book an appointment
                    </h3>
                    <span className="pension-wise-logo">
                      <img src={PensionWiseLogo} />
                    </span>
                  </div>
                  <div className="btn-card">
                    <Row className="appoint">
                      <Col lg={1} md={1} sm={12}>
                        <Icons variant="icon-twenty-four-px" iconname="call" />
                      </Col>
                      <Col xl={4} lg={5} md={5} sm={12}>
                        <span className="bdr-bottom"> 0800 138 3944</span>
                        <br />
                        between 8am and 8pm Monday to Friday
                      </Col>
                      <Col lg={5} md={5} sm={12}>
                        <span className="bdr-bottom"> +44 20 3733 3495</span>
                        <br />
                        for overseas members
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={1} md={1} sm={12}>
                        <Icons
                          variant="icon-twenty-four-px"
                          iconname="icons-computer"
                        />
                      </Col>
                      <Col xl={3} lg={4} md={4} sm={12}>
                        <span className="bdr-bottom">
                          {" "}
                          <a
                            href="https://moneyhelper.org.uk/en/pensions-and-retirement/pension-wise/book-a-free-pension-wise-appointment/book-a-phone-appointment"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Book an appointment now
                          </a>
                        </span>
                        <span className="icon ext-link">
                          <Icons
                            iconname="external-link"
                            variant="icon-sixteen-px"
                          />
                        </span>
                      </Col>
                      <Col
                        lg={1}
                        md={1}
                        className="pipe-line d-flex justify-content-center align-items-center"
                      >
                        <span className="vertical-divider"></span>
                      </Col>
                      <Col lg={4} md={4} sm={12}>
                        <span className="bdr-bottom">
                          <a
                            href="https://www.moneyhelper.org.uk/en/pensions-and-retirement/pension-wise"
                            target="_blank"
                            rel="noreferrer"
                          >
                            moneyhelper.org.uk/PensionWise
                          </a>
                        </span>
                        <span className="icon ext-link">
                          <Icons
                            iconname="external-link"
                            variant="icon-sixteen-px"
                          />
                        </span>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col lg={10} md={11} sm={12}>
                  Alternatively, we can book an appointment for you. Please call
                  us on 0345 072 6780 and our UK based team will get that sorted
                  for you.
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
        <div className="footer-btn-container">
          <Buttons
            handleClick={handleBack}
            className="secondary back-btn"
            name="Back"
          />
          <Buttons
            handleClick={() => handleContinue()}
            className="primary"
            name="Continue"
            disabled={selectedCheck.length === 0 && !selectedRadio}
          />
        </div>
      </Card.Body>
    </Card>
  );
};

export default PensionWiseGuidance;
